<template>
  <section>
    <v-card class="table-container">
      <template>
        <v-data-table :headers="headers" :items="products" :search="search" sort-by="name">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="section-title">Produtos</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Procurar"
                class="mr-2 mb-4"
                single-line
                hide-details
              ></v-text-field>
              
              <v-btn 
                color="#90A99C"
                fab
                dark
                small
                class="plus-btn mb-2 mr-2"
                @click="export_excel(products)"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>

              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn @click="estado='novo'" color="primary" fab dark small class="plus-btn mb-2" v-on="on">
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="title-form headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="editedItem.g_category_id"
                            :items="categories"
                            item-value="g_category_id"
                            item-text="name"
                            label="Categoria"
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <v-select
                            v-model="editedItem.g_family_id"
                            :items="families"
                            item-value="g_family_id"
                            item-text="name"
                            label="Família"
                          ></v-select>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field label="Glintt Product ID" :id="editedItem.id+'_g_product_id'" v-model="editedItem.g_product_id"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Nome" :id="editedItem.id+'_name'" v-model="editedItem.name"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Tags" :id="editedItem.id+'_tags'" v-model="editedItem.tags"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Descrição Feed" :id="editedItem.id+'_feed_description'" v-model="editedItem.feed_description" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea label="Descrição" :id="editedItem.id+'_description'" v-model="editedItem.description" required></v-textarea>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Frase de abertura" :id="editedItem.id+'_open_sentence'" v-model="editedItem.open_sentence" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Imagem Marca" :id="editedItem.id+'_brand_image'" v-model="editedItem.brand_image" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Vantagem 1" :id="editedItem.id+'_advantage_1'" v-model="editedItem.advantage_1" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Vantagem 2" :id="editedItem.id+'_advantage_2'" v-model="editedItem.advantage_2" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Vantagem 3" :id="editedItem.id+'_advantage_3'" v-model="editedItem.advantage_3" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Vantagem 4" :id="editedItem.id+'_advantage_4'" v-model="editedItem.advantage_4" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Vantagem 5" :id="editedItem.id+'_advantage_5'" v-model="editedItem.advantage_5" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Descrição vantagem 1" :id="editedItem.id+'_advantage_desc_1'" v-model="editedItem.advantage_desc_1" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Descrição vantagem 2" :id="editedItem.id+'_advantage_desc_2'" v-model="editedItem.advantage_desc_2" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Descrição vantagem 3" :id="editedItem.id+'_advantage_desc_3'" v-model="editedItem.advantage_desc_3" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Descrição vantagem 4" :id="editedItem.id+'_advantage_desc_4'" v-model="editedItem.advantage_desc_4" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Descrição vantagem 5" :id="editedItem.id+'_advantage_desc_5'" v-model="editedItem.advantage_desc_5" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Trivia" :id="editedItem.id+'_trivia'" v-model="editedItem.trivia" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Action Sentence" :id="editedItem.id+'_action_sentence'" v-model="editedItem.action_sentence" required></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field label="Icon Destaque 1" :id="editedItem.id+'_b_img_1'" v-model="editedItem.b_img_1" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Titulo Destaque 1" :id="editedItem.id+'_b_title_1'" v-model="editedItem.b_title_1" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Descrição Destaque 1" :id="editedItem.id+'_b_desc_1'" v-model="editedItem.b_desc_1" required></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field label="Icon Destaque 2" :id="editedItem.id+'_b_img_2'" v-model="editedItem.b_img_2" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Titulo Destaque 2" :id="editedItem.id+'_b_title_2'" v-model="editedItem.b_title_2" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Descrição Destaque 2" :id="editedItem.id+'_b_desc_2'" v-model="editedItem.b_desc_2" required></v-text-field>
                        </v-col>
                        
                        <v-col cols="12">
                          <v-text-field label="Preço" :id="editedItem.id+'_price'" v-model="editedItem.price" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Informação de preço" :id="editedItem.id+'_price_info'" v-model="editedItem.price_info" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Condições preço" :id="editedItem.id+'_price_condition'" v-model="editedItem.price_condition" required></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field label="Preço Desconto" :id="editedItem.id+'_discount_price'" v-model="editedItem.discount_price" required></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field label="Condições Serviço 1" :id="editedItem.id+'_service_condition_1'" v-model="editedItem.service_condition_1" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Condições Serviço 2" :id="editedItem.id+'_service_condition_2'" v-model="editedItem.service_condition_2" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Condições Serviço 3" :id="editedItem.id+'_service_condition_3'" v-model="editedItem.service_condition_3" required></v-text-field>
                        </v-col>
                        
                        <v-col cols="12">
                          <v-file-input 
                            v-model="editedItem.video"
                            label="Video"
                            hint="Apenas para acrescentar/substituir"
                            persistent-hint
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="editedItem.image_1"
                            label="Imagem 1 (Principal)"
                            hint="Apenas para acrescentar/substituir"
                            persistent-hint
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="editedItem.image_2"
                            label="Imagem 2"
                            hint="Apenas para acrescentar/substituir"
                            persistent-hint
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="editedItem.image_3"
                            label="Imagem 3"
                            hint="Apenas para acrescentar/substituir"
                            persistent-hint
                          ></v-file-input>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="mt-4 mb-4">
                          <hr>
                          <h4 class="mb-0">Documentos</h4>
                          <small class="mt-0">Apagar nomes para não mostrar documento</small>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field 
                            v-model="editedItem.link_1_name" 
                            label="Nome Documento 1"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="link_1" 
                            label="Documento 1"
                          ></v-file-input>
                        </v-col>
                        
                        <v-col cols="12">
                          <v-text-field 
                            v-model="editedItem.link_2_name" 
                            label="Nome Documento 2"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="link_2" 
                            label="Documento 2"
                          ></v-file-input>
                        </v-col>
                        
                        <v-col cols="12">
                          <v-text-field 
                            v-model="editedItem.link_3_name" 
                            label="Nome Documento 3"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="link_3" 
                            label="Documento 3"
                          ></v-file-input>
                        </v-col>
                        
                        <v-col cols="12">
                          <v-text-field 
                            v-model="editedItem.link_4_name" 
                            label="Nome Documento 4"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="link_4" 
                            label="Documento 4"
                          ></v-file-input>
                        </v-col>
                        
                        <v-col cols="12">
                          <v-text-field 
                            v-model="editedItem.link_5_name" 
                            label="Nome Documento 5"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="link_5" 
                            label="Documento 5"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <p>{{productMsg}}</p>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="mr-0 mb-2" x-small outlined fab @click="close">
                      <v-icon>mdi mdi-close</v-icon>
                    </v-btn>
                    <v-btn color="primary" class="mr-2 mb-2" x-small fab @click="save">
                      <v-icon>mdi mdi-content-save</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn x-small depressed class="mr-2" fab dark color="#90A99C" @click="editItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn x-small depressed fab dark color="#7E1416" @click="deleteItem(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </v-card>
  </section>
</template>

<script>
import {json2excel} from 'js2excel'

export default {
  name: "Produtos",
  data: () => ({
    search: '',
    dialog: false,
    headers: [
      { text: "ID", align: "start", sortable: true, value: "id" },
      { text: "Glintt product ID", sortable: true, value: "g_product_id" },
      { text: "Nome Produto", sortable: true, value: "name" },
      { text: "Descrição Feed", value: "feed_description" },
      { text: "Preço", value: "price" },
      { text: "Desconto?", value: "in_discount" },
      { text: "Acções", value: "actions", align: "end", sortable: false }
    ],
    products: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    estado: "",
    productMsg: "",
    createResult: {},
    updateResult: {},

    image_1: [],
    image_2: [],
    image_3: [],
    video: [],
    form_data: new FormData(),
    categories: [],
    families: [],

    link_1: [],
    link_2: [],
    link_3: [],
    link_4: [],
    link_5: []

  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nova Produto" : "Editar Produto";
    }
  },

  watch: {
    dialog(val) {
      if(val == false) {
        this.close()
        this.productMsg = ""
        this.form_data = new FormData()
        this.editedItem = {}
        this.image_1 = []
        this.image_2 = []
        this.image_3 = []
        this.video = []
        
        this.link_1 = []
        this.link_2 = []
        this.link_3 = []
        this.link_4 = []
        this.link_5 = []
      }
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    export_excel: async function(data) {
      try {
          json2excel({
              data,
              name: 'products-list',
              formateDate: 'yyyy-mm-dd'
          });
      } catch (e) {
        alert('export error');
      }
    },
    async initialize() {
      await this.$store.dispatch('collectProducts', this)
      await this.$store.dispatch('collectCategories', this)
      await this.$store.dispatch('collectFamilies', this)
    },

    editItem(item) {
      this.editedIndex = this.products.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.estado = "editar";
    },

    async deleteItem(item) {
      if (!confirm("Tem a certeza que quer eliminar esta Produto?")){
        return
      }
      this.deletedItem = item

      this.deletedItem.status = 0

      await this.$store.dispatch("deleteProducts", this);
      // this.initialize();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.productMsg = "A validar...";
      
      delete this.editedItem.category_name
      delete this.editedItem.in_discount
      delete this.editedItem.g_area_id
      delete this.editedItem.area_color
      delete this.editedItem.area_name
      delete this.editedItem.parent_id
      delete this.editedItem.last_update_dt
      delete this.editedItem.update_count

      console.log(this.editedItem.g_family_id)

      if(this.editedItem.g_family_id == null) {
        this.editedItem.g_family_id = '0'
      }
      if(this.editedItem.g_category_id == null) {
        this.editedItem.g_category_id = '0'
      }
      
      let images = ['image_1', 'image_2', 'image_3', 'video']
      for(let i of images) {
        if(typeof this[i].name == 'string') {
          this.editedItem[i] = this[i]
        }
      }
      for(let i of images) {
        if(this.editedItem[i] == 'null' || this.editedItem[i] == undefined || this.editedItem[i] == '') {
          this.editedItem[i] = "null"
        }
      }

      let files = ['link_1', 'link_2', 'link_3', 'link_4', 'link_5']
      for(let i of files) {
        if(typeof this[i].name == 'string') {
          this.editedItem[i] = this[i]
        }
      }
      for(let i of files) {
        if(this.editedItem[i] == 'null' || this.editedItem[i] == undefined || this.editedItem[i] == '') {
          this.editedItem[i] = "null"
        }
      }

      if (this.editedItem.name == "") {
        this.productMsg = "Introduza o nome da Produto";
      } 
      else if ((this.editedItem.image_1 == "" || typeof this.editedItem.image_1 == 'undefined') && (this.editedItem.video == "" || typeof this.editedItem.video == 'undefined') && this.editedIndex == -1) {
        this.productMsg = "Selecione pelo menos a imagem principal ou um video";
      } 
      else {

        var form_data = new FormData();

        Object.keys(this.editedItem).forEach(key => form_data.append(key, this.editedItem[key]));
        this.form_data = form_data

        if (this.editedIndex > -1) {
          await this.$store.dispatch("updateProducts", this)
        } 
        else {
          await this.$store.dispatch("createProducts", this)
        }
      }
    }
  }
};
</script>
